var map = {
	"./择时.svg": "f4xc",
	"./数据.svg": "myum",
	"./自定义.svg": "pacB",
	"./选股.svg": "n5zY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VzK0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/formatFonts ^\.\/.*\.svg$
// module id = VzK0
// module chunks = 44